import fp from 'lodash/fp';
import React from 'react';
import { format } from 'date-fns';
import { FiCheck } from 'react-icons/fi';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { branch, compose, lifecycle, renderComponent, withProps } from "recompose";
import { bindActionCreators } from 'redux';
import { cpdCategorysActions } from "../../../../../../../../state/modules/areas-of-advice";
import { externalCpdActions } from "../../../../../../../../state/modules/external-cpd";
import { sessionActions } from "../../../../../../../../state/modules/session";
import Loading from '../../../../../../../pages/loading';

const mapStateToProps = (state) => ({
  adminToken: state.session.idToken,
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  isRunningEndpoint: state.externalCpd.request.add.isFetching,
});

const mapDispatchToProps = (dispatch) => ({
  authenticate: bindActionCreators(sessionActions.session.authenticate, dispatch),
  getCpdCategorys: bindActionCreators(cpdCategorysActions.cpdCategorys.get, dispatch),
  action: bindActionCreators(externalCpdActions.externalCpd.add, dispatch),
});

const add = ({ isRunningEndpoint, isRunningTest }) => {
  const isRunning = isRunningTest && isRunningEndpoint
  return <div>
    test add external cpd
    {
      isRunning ?
        <Spinner name='circle' className='spinner' fadeIn='none' /> :
        <FiCheck />
    }
  </div>
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.getCpdCategorys()
    }
  }),
  branch(
    ({ cpdCategorys }) => !cpdCategorys || cpdCategorys.length === 0,
    renderComponent(Loading)
  ),
  withProps(
    ({ cpdCategorys }) => {
      const externalCpd = {
        timeEarned: format(new Date(), 'yyyy-MM-dd'),
        activityName: 'test',
        providerName: 'test',
        accreditationNumber: '1',
        notes: '',
        isTasaCpd: false,
        contentType: 'Article',
        status: 'Approved'
      }
      const userCpdPoints = fp.map(
        ({ id }) => ({
          cpdCategoryId: id,
          points: 1,
          isMicroCpd: false
        })
      )(cpdCategorys)

      const params = [
        externalCpd,
        userCpdPoints,
        [],
        undefined,
        true
      ]
      return {
        params
      }
    }
  ),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        isRunningTest,
        users,
        authenticate,
        adminToken,
        action,
        params,
        isRunningEndpoint,
        onComplete
      } = this.props

      if (isRunningTest && !prevProps.isRunningTest) {
        const mockUser = fp.first(users)
        authenticate(adminToken, mockUser.id, null, null, true)
        action(...params)
      }

      if (!isRunningEndpoint && prevProps.isRunningEndpoint) {
        onComplete()
      }

      if (!isRunningTest && prevProps.isRunningTest) {
        authenticate(adminToken, null, null, null, true)
      }
    }
  })
)(add)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/endpoints/external-cpd/add.js